import { render, staticRenderFns } from "./CombinationMedicalAndNursingCareIntroduce.vue?vue&type=template&id=f1a99210&scoped=true&"
import script from "./CombinationMedicalAndNursingCareIntroduce.vue?vue&type=script&lang=js&"
export * from "./CombinationMedicalAndNursingCareIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./CombinationMedicalAndNursingCareIntroduce.vue?vue&type=style&index=0&id=f1a99210&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a99210",
  null
  
)

export default component.exports